import React from "react"
import { CopySvg } from "../../assets/svg"
import useClipboard from "react-use-clipboard"
import { useTranslation } from "next-i18next"
import { twMerge } from "tailwind-merge"
import clsx from "clsx"

interface CopyProps {
    text: string
    classNames?: string

    iconClassName?: string
}

export const Copy = ({ text, classNames, iconClassName }: CopyProps) => {
    const { t: tCommon } = useTranslation("common")

    const [isCopied, setCopied] = useClipboard(text, { successDuration: 2000 })

    return (
        <div className={twMerge(clsx("relative hover:z-10 hover-apply-child:flex", classNames))}>
            <CopySvg
                width={13}
                height={15}
                onClick={setCopied}
                className={twMerge(clsx("fill-neutral-1 hover:opacity-80", iconClassName))}
            />
            <div
                className={twMerge(
                    clsx(
                        "b-flex-center b-inset-center p-hover top-auto -bottom-[26px] hidden h-[18px] w-[54px] translate-y-0 rounded-[2px] border border-[#DFDDDE] bg-white  text-10",
                        isCopied && "w-[54px]"
                    )
                )}
            >
                <div className="absolute -top-[4px] z-20 h-[6px] w-[6px] rotate-45 border-t border-l border-[#DFDDDE] bg-white"></div>
                <span className={"relative z-30"}>{isCopied ? tCommon("copied") : tCommon("copyToClipboard")}</span>
            </div>
        </div>
    )
}
